import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8"
}
const _hoisted_2 = { class: "max-w-md w-full space-y-8 bg-white p-10 rounded-md" }
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = { class: "rounded-md gap-4 flex flex-col" }
const _hoisted_5 = { class: "text-sm" }
const _hoisted_6 = { class: "mt-1" }
const _hoisted_7 = { class: "inset-y-0 right-0 flex items-center pr-2 pointer-events-none" }
const _hoisted_8 = { class: "block truncate" }
const _hoisted_9 = {
  key: 0,
  class: "absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "text-sm" }
const _hoisted_12 = { class: "mt-1" }
const _hoisted_13 = { class: "inset-y-0 right-0 flex items-center pr-2 pointer-events-none" }
const _hoisted_14 = { class: "block truncate" }
const _hoisted_15 = {
  key: 0,
  class: "absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600"
}
const _hoisted_16 = { class: "flex-row flex gap-4" }
const _hoisted_17 = {
  class: "group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md items-center gap-1 text-white",
  style: {"background-color":"#3c82f6"},
  type: "submit"
}
const _hoisted_18 = { class: "flex justify-between" }
const _hoisted_19 = { class: "text-sm" }
const _hoisted_20 = { class: "mt-1" }
const _hoisted_21 = { class: "flex justify-between" }
const _hoisted_22 = { class: "text-sm" }
const _hoisted_23 = { class: "mt-1" }

import { inject, onMounted, ref, watch } from "vue";
import { Listbox, ListboxButton, ListboxOption, ListboxOptions, Switch } from "@headlessui/vue";
import { useStore } from "vuex";
import { AxiosInstance } from "axios";
interface PaymentAccount {
  id: string
  operatorId: string
  specialCode: string
  appId: string
  secret: string
  apiUrl: string
  paymentId: string
  merchantId: string
  clientId: string
  clientSecret: string
  useWithdraw: boolean
  useDeposit: boolean
  isActive: boolean
  createdAt: string
  updatedAt: string,
  minWithdraw: number,
  minDeposit: number,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentConfigV2',
  setup(__props) {

const CheckIcon = require("@heroicons/vue/solid/CheckIcon");
const disableWithdraw = ref({
  is_active: false
})
const disableDeposit = ref({
  is_active: false
})
const store = useStore();
const axios = inject("$axios") as AxiosInstance;
const isLoading = ref(false);
const accountList = ref<PaymentAccount[]>([]);
const form = ref<{
  depositAccount: PaymentAccount | any;
  withdrawAccount: PaymentAccount | null;
}>({ depositAccount: null, withdrawAccount: null });
const isShow = ref<Boolean>(false)
const isShowUseWithdraw = ref<Boolean>(false)
const onSave = async () => {
  isLoading.value = true;

  try {
    if (confirm("Are you sure?")) {
      const selectedOperatorId = store.state.selectedOperator.operatorId;

      const paymentGatewayUseDeposit = form.value.depositAccount ? {
        paymentGatewayUseDeposit: {
          id: form.value.depositAccount.id,          
          paymentName: form.value.depositAccount.appId,
          operatorId: selectedOperatorId,
        }
      } : null;

      const paymentGatewayUseWithdraw = form.value.withdrawAccount ? {
        paymentGatewayUseWithdraw: {
          id: form.value.withdrawAccount.id,          
          paymentName: form.value.withdrawAccount.appId,
          operatorId: selectedOperatorId,
        }
      } : null;

      const payload = {
        operatorId: store.state.selectedOperator.operatorId,
        ...paymentGatewayUseDeposit,
        ...paymentGatewayUseWithdraw,
      };

      await axios.post(
        `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/operator-payment-gateway/setup`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      await getAccount();
    }
  } catch (error) {
    console.error('An error occurred while saving:', error);
  } finally {
    isLoading.value = false;
  }
};


const onCancel = async () => {
  const defaultAccountList = accountList.value
  form.value.depositAccount = defaultAccountList.find(
    (pa: PaymentAccount) => pa.useDeposit || null
  ) || null
  form.value.withdrawAccount = defaultAccountList.find(
    (pa: PaymentAccount) => pa.useWithdraw) || null
}

const getAccount = async () => {
  isLoading.value = true
  let payload = {
    operatorId: store.state.selectedOperator.operatorId,
  }
  const result = await axios
    .post<PaymentAccount[]>(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/operator-payment-gateway/operator`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    .then(({ data }) => data)

  const withdraw = result.find((pa: PaymentAccount) => pa.useWithdraw) || null
  const deposit = result.find((pa: PaymentAccount) => pa.useDeposit) || null
  form.value.withdrawAccount = withdraw
  form.value.depositAccount = deposit
  accountList.value = result
  disableWithdraw.value.is_active = result.find((data: { useWithdraw: boolean; }) => {
    return data.useWithdraw == true
  }) ? false : true
  disableDeposit.value.is_active = result.find((data: { useDeposit: boolean; }) => {
    return data.useDeposit == true
  }) ? false : true
  isLoading.value = false
}

const toggleDisableWithdraw = async () => {
  disableWithdraw.value.is_active = !disableWithdraw.value.is_active;
  if (disableWithdraw.value.is_active) {
    try {
      isLoading.value = true
      let payload = {
        operatorId: store.state.selectedOperator.operatorId,
      }
      const { data } = await axios.post(
        `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/operator-payment-gateway/setup/disable-withdraw`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      if (!data) {
        throw new Error('err')
      }

      getAccount()

      isLoading.value = false
    } catch (error) {
      isLoading.value = false
    }
  }
}

const toggleDisableDeposit = async () => {
  disableDeposit.value.is_active = !disableDeposit.value.is_active;
  if (disableDeposit.value.is_active) {
    try {
      isLoading.value = true
      let payload = {
        operatorId: store.state.selectedOperator.operatorId,
      }
      const { data } = await axios.post(
        `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/operator-payment-gateway/setup/disable-deposit`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      if (!data) {
        throw new Error('err')
      }
      getAccount()
      isLoading.value = false
    } catch (error) {
      isLoading.value = false
    }
  }
}
// watch(
//     () => [form.value.depositAccount, form.value.withdrawAccount],
//     (val) => {
//
//     }
// );
onMounted(() => {
  if (store.state.user.permissions.includes('OPERATOR.UPDATE.FINANCE')) isShow.value = true
  isShowUseWithdraw.value = store.state.selectedOperator.paymentVersion == 'v3' ? false:true
  getAccount()
})

return (_ctx: any,_cache: any) => {
  const _component_SelectorIcon = _resolveComponent("SelectorIcon")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (isShow.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.$t("messages.navigation.paymentConfigV2")), 1),
          _createElementVNode("form", {
            action: "#",
            class: "mt-8 space-y-6",
            method: "POST",
            onSubmit: _withModifiers(onSave, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("messages.paymentConfig.deposit")), 1),
                _createVNode(_unref(Listbox), {
                  class: "relative",
                  modelValue: form.value.depositAccount,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.depositAccount) = $event))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_unref(ListboxButton), { class: "w-full py-2 pl-3 text-left bg-white rounded-lg shadow-md cursor-default focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-white focus-visible:ring-offset-orange-300 focus-visible:ring-offset-2 focus-visible:border-indigo-500 sm:text-sm" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_7, [
                            _createElementVNode("span", _hoisted_8, _toDisplayString(form.value.depositAccount?.appId ? `${form.value.depositAccount?.appId}
                      (${form.value.depositAccount?.paymentName})
                      ` : '-'), 1),
                            _createVNode(_component_SelectorIcon, {
                              "aria-hidden": "true",
                              class: "w-5 h-5 text-gray-400 ml-auto"
                            })
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_Transition, {
                        "leave-active-class": "transition duration-100 ease-in",
                        "leave-from-class": "opacity-100",
                        "leave-to-class": "opacity-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ListboxOptions), {
                            class: "absolute w-full max-h-60 mt-1 py-1 z-100 bg-white shadow-lg rounded-md text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm",
                            style: {"z-index":"100"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accountList.value, (account) => {
                                return (_openBlock(), _createBlock(_unref(ListboxOption), {
                                  key: account.id,
                                  value: account,
                                  as: "template"
                                }, {
                                  default: _withCtx(({ active, selected }) => [
                                    _createElementVNode("li", {
                                      class: _normalizeClass([
                        active
                          ? 'text-amber-900 bg-amber-100'
                          : 'text-gray-900',
                        'cursor-default select-none relative py-2 pl-10 pr-4',
                      ])
                                    }, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass([
                          selected ? 'font-medium' : 'font-normal',
                          'block truncate',
                        ])
                                      }, _toDisplayString(`${account.appId} (${account.paymentName})`), 3),
                                      selected
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                            _createVNode(_unref(CheckIcon), {
                                              "aria-hidden": "true",
                                              class: "w-5 h-5"
                                            })
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 2)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              (isShowUseWithdraw.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("messages.paymentConfig.withdraw")), 1),
                    _createVNode(_unref(Listbox), {
                      class: "relative",
                      modelValue: form.value.withdrawAccount,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.withdrawAccount) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_unref(ListboxButton), { class: "w-full py-2 pl-3 text-left bg-white rounded-lg shadow-md cursor-default focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-white focus-visible:ring-offset-orange-300 focus-visible:ring-offset-2 focus-visible:border-indigo-500 sm:text-sm" }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_13, [
                                _createElementVNode("span", _hoisted_14, _toDisplayString(form.value.withdrawAccount?.appId ? `${form.value.withdrawAccount?.appId}  (${form.value.withdrawAccount?.paymentName})
                      ` : '-'), 1),
                                _createVNode(_component_SelectorIcon, {
                                  "aria-hidden": "true",
                                  class: "w-5 h-5 text-gray-400 ml-auto"
                                })
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_Transition, {
                            "leave-active-class": "transition duration-100 ease-in",
                            "leave-from-class": "opacity-100",
                            "leave-to-class": "opacity-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(ListboxOptions), {
                                class: "absolute w-full max-h-60 mt-1 py-1 z-100 bg-white shadow-lg rounded-md text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm",
                                style: {"z-index":"100"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accountList.value, (account) => {
                                    return (_openBlock(), _createBlock(_unref(ListboxOption), {
                                      key: account.id,
                                      value: account,
                                      as: "template"
                                    }, {
                                      default: _withCtx(({ active, selected }) => [
                                        _createElementVNode("li", {
                                          class: _normalizeClass([
                        active
                          ? 'text-amber-900 bg-amber-100'
                          : 'text-gray-900',
                        'cursor-default select-none relative py-2 pl-10 pr-4',
                      ])
                                        }, [
                                          _createElementVNode("span", {
                                            class: _normalizeClass([
                          selected ? 'font-medium' : 'font-normal',
                          'block truncate',
                        ])
                                          }, _toDisplayString(`${account.appId} (${account.paymentName})`), 3),
                                          selected
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                                _createVNode(_unref(CheckIcon), {
                                                  "aria-hidden": "true",
                                                  class: "w-5 h-5"
                                                })
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 2)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                class: "group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white",
                style: {"background-color":"#ef5050"},
                type: "reset",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (onCancel()))
              }, _toDisplayString(_ctx.$t("messages.paymentConfig.cancel")), 1),
              _createElementVNode("button", _hoisted_17, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("messages.paymentConfig.save")), 1),
                _withDirectives(_createVNode(_component_font_awesome_icon, {
                  icon: ['fas', 'circle-notch'],
                  class: "text-white",
                  spin: ""
                }, null, 512), [
                  [_vShow, isLoading.value]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("messages.paymentConfig.disableDeposit")), 1),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_unref(Switch), {
                  modelValue: disableDeposit.value.is_active,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((disableDeposit.value.is_active) = $event)),
                  class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full", disableDeposit.value.is_active
                ? 'bg-blue-400'
                : 'bg-red-500'
                ]),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleDisableDeposit()))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass([disableDeposit.value.is_active
                ? 'translate-x-6'
                : 'translate-x-1'
                , "inline-block h-4 w-4 transform rounded-full bg-white"])
                    }, null, 2)
                  ]),
                  _: 1
                }, 8, ["modelValue", "class"])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("messages.paymentConfig.disableWithdraw")), 1),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_unref(Switch), {
                  modelValue: disableWithdraw.value.is_active,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((disableWithdraw.value.is_active) = $event)),
                  class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full", disableWithdraw.value.is_active
                ? 'bg-blue-400'
                : 'bg-red-500'
                ]),
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (toggleDisableWithdraw()))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass([disableWithdraw.value.is_active
                ? 'translate-x-6'
                : 'translate-x-1'
                , "inline-block h-4 w-4 transform rounded-full bg-white"])
                    }, null, 2)
                  ]),
                  _: 1
                }, 8, ["modelValue", "class"])
              ])
            ])
          ], 40, _hoisted_3)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})